import { render, staticRenderFns } from "./popup-end-game.vue?vue&type=template&id=7ae32ce5&scoped=true&"
import script from "./popup-end-game.vue?vue&type=script&lang=js&"
export * from "./popup-end-game.vue?vue&type=script&lang=js&"
import style0 from "./popup-end-game.vue?vue&type=style&index=0&id=7ae32ce5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae32ce5",
  null
  
)

export default component.exports